var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWritingpoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33325 8C6.54239 8 8.33325 6.20914 8.33325 4C8.33325 1.79086 6.54239 0 4.33325 0C2.12411 0 0.333252 1.79086 0.333252 4C0.333252 6.20914 2.12411 8 4.33325 8Z",
    fill: "#FF5D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWritingpoint);
export default __webpack_public_path__ + "static/media/writingpoint.3e2524873be1194511d2ebc5140fbeed.svg";
export { ForwardRef as ReactComponent };